<tt-page *ngIf="!!setting">
    <tt-page-heading *ngIf="!!setting.page_heading" [ttModel]="setting.page_heading"></tt-page-heading>

    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="info"></ng-container>
            <tt-input ttLabel="filtervalue" ttFocus="true" [(ttModel)]="setting.filtervalue" ttShowClearButton></tt-input>

            <tt-tabs [(ttSelectedId)]="setting.gb_choicepossibilitylist_type" (ttSelectedIdChange)="onTabChange()">
                <tt-tab ttId="POSSIBLE" ttLabel="gb_choicepossibilitylist_type_possible"></tt-tab>
                <tt-tab ttId="NOTPOSSIBLE" ttLabel="gb_choicepossibilitylist_type_notpossible"></tt-tab>
                <tt-tab ttId="ALL" ttLabel="gb_choicepossibilitylist_type_all"></tt-tab>
            </tt-tabs>
        </tt-card>

        <tt-list ttCheckboxSelection [(ttData)]="itemsListChoicePossibilities" [ttFilter]="setting.filtervalue" ttGoto="false" ttButtonsPosition="left"></tt-list>

        <tt-card *ngIf="setting.restrictpossibility === '1'">
            <tt-button-save ttText="choicepossibilitylist_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
        </tt-card>
    </div>

    <div class="height-full" *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-card class="col-xs-12 col-md-4 p-5">
            <ng-container *ngTemplateOutlet="info"></ng-container>
        </tt-card>

        <tt-grid *ngIf="!!grid" class="flex-1 p-5" [(ttOptions)]="grid"></tt-grid>
    </div>
</tt-page>

<ng-template #info>
    <ng-container *ngIf="!!setting">
        <tt-input ttLabel="prod_name_choice" [ttModel]="setting.prod_name_choice" [ttButtons]="productNameChoiceButtons" ttReadonly></tt-input>
        <label *ngIf="setting.choice_restrictpossibility_info !== ''" class="checklist-h2 col-xs-12" ttHeader="setting.choice_restrictpossibility_info"></label>
        <tt-input *ngIf="setting.prod_id !== setting.choice_belong_to_prod_id" ttLabel="choice_belong_to_prod_name" [ttModel]="setting.choice_belong_to_prod_name" ttReadonly></tt-input>
    </ng-container>
</ng-template>
